import { render, staticRenderFns } from "./appointment-calendar.vue?vue&type=template&id=4380c859&"
import script from "./appointment-calendar.vue?vue&type=script&lang=js&"
export * from "./appointment-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports